<template>
    <div class="b_recommended_articles">
        <div class="container">
            <div class="title">
                כתבות מומלצות
            </div>

            <div class="articles_list flex">
                <single-recommended
                    v-for="article in articles"
                    :key="article.id"
                    :article="article"
                />
            </div>

            <div v-if="showMore" class="btn_wrapper text_center">
                <button
                    class="btn btn_green_empty"
                    type="button"
                    @click="fetchArticles(true)"
                >
                    כתבות נוספות
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SingleRecommended from '@/components/articles/SingleRecommended';

export default {
    components: {
        SingleRecommended
    },

    data() {
        return {
            articles: [],
            page: 1,
            perPage: 3,
            total: 0
        };
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        }),

        showMore() {
            return this.articles.length < this.total;
        }
    },

    watch: {
        selectedCampus() {
            this.fetchArticles();
        }
    },

    created() {
        this.fetchArticles();
    },

    methods: {
        ...mapActions({
            getArticles: 'articles/index'
        }),

        async fetchArticles(getMore = false) {
            try {
                this.page = getMore ? this.page + 1 : 1;

                const { rows, count } = await this.getArticles({
                    page: this.page,
                    perPage: this.perPage,
                    source: 'feed'
                });

                this.articles = getMore ? [...this.articles, ...rows] : rows;
                this.total = count;
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        }
    }
};
</script>
